import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Card } from 'antd';
import { useWatch } from 'react-hook-form';
import { type IReference } from '../../../../../../expressions/references/IReference.ts';
import { type IAsyncService } from '../../../../../../expressions/repository/async/context/IAsyncService.ts';
import { AsyncServiceInputConfigForm } from '../AsyncServiceInputConfigForm.tsx';
import { ServiceInputSelect } from '../ServiceInputSelect.tsx';
import { ServiceOutputSelect } from '../ServiceOutputSelect.tsx';

export interface IAsyncSelectConfigFormProps {
  selected: IAsyncService | null | undefined;
  hasInputs: boolean | undefined;
  searchField: string | null | undefined;
  references: IReference[];
}

export function AsyncSelectServiceConfigForm(
  props: IAsyncSelectConfigFormProps,
) {
  const { selected, hasInputs, references, searchField } = props;

  const renderType = useWatch({ name: 'renderType' });

  if (renderType !== 'select') return null;

  if (!selected) return null;

  return (
    <>
      <div style={{ paddingTop: '8px' }}>
        <Card size="small" title="Configura struttura">
          <FormItem
            name="labelFields"
            help="Se vengono selezionati più campi, saranno mostrati separati da un '-' nell'ordine configurato"
          >
            <ServiceOutputSelect
              label="Etichetta"
              service={selected}
              name="labelFields"
              mode="multiple"
            />
          </FormItem>
          <FormItem name="valueField">
            <ServiceOutputSelect
              label="Valore"
              service={selected}
              name="valueField"
            />
          </FormItem>
          <div style={{ marginBottom: '8px' }}>
            <FormItem
              name="searchField"
              help="È possibile configurare il campo come “autocompletamento” tramite chiamate API inserendo il parametro della chiamat per cui filtrare. Se lasciato vuoto il filtro verrà effettuato direttamente lato browser sull'etichetta configurata."
            >
              <ServiceInputSelect
                label="Filtro ricerca"
                service={selected}
                name="searchField"
              />
            </FormItem>
          </div>
        </Card>
      </div>
      {hasInputs && (
        <AsyncServiceInputConfigForm
          name="inputs"
          service={selected}
          references={references}
          disableInput={inputName => inputName === searchField}
        />
      )}
    </>
  );
}
